export const downloadFile = ({ dispatch }, documentUrl) => {
  if (documentUrl !== null) {
    var elem = document.getElementById('tempLink')
    if (elem) {
      document.body.appendChild(elem)
    }
    var link = document.createElement('a')
    link.setAttribute('href', documentUrl)
    link.setAttribute('id', 'tempLink')
    document.body.appendChild(link)
    link.click()
  }
}
